import { IonIcon } from '@ionic/react';
import { radioOutline } from 'ionicons/icons';
import { withAvatarCacheBuster } from '../../../../lib/avatarUrl';
import { cn } from '../../../../lib/utils';

interface ChannelImageProps {
  image?: string | null;
  /** Channel's updatedAt, used to cache-bust the image after a re-upload. */
  updatedAt?: string | null;
  name?: string | null;
  /** Rendered size in pixels (width = height). */
  size?: number;
  className?: string;
}

/**
 * Circular channel picture. Channels without an image show the channels tab
 * icon on a light background.
 */
export const ChannelImage = ({ image, updatedAt, name, size = 64, className }: ChannelImageProps) => {
  const src = withAvatarCacheBuster(image, updatedAt);
  const label = name ? `Imagen del canal ${name}` : 'Imagen del canal';

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-100',
        className
      )}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={label} className="h-full w-full object-cover" />
      ) : (
        <IonIcon
          icon={radioOutline}
          color="primary"
          aria-label={label}
          data-testid="channel-image-fallback"
          style={{ fontSize: Math.round(size * 0.55) }}
        />
      )}
    </div>
  );
};
